import { createRoute } from "@tanstack/react-router";
import { LeadsByChannelCard } from "@/components/teams/leads-by-channel-card";
import { TeamRosterPage } from "@/components/teams/team-roster-page";
import { Route as authenticatedRoute } from "../_authenticated";

const members = [
  {
    name: "Alex Sohn",
    title: "Marketing Director",
    ownerId: "43404667-980f-4ec1-8900-0abfbfafd629",
    image: "/assets/headshots/alex-sohn.png",
  },
  {
    name: "Hope Holebrook",
    title: "Marketing Specialist",
    ownerId: "7e18e77a-415d-4ddd-b8c4-92a7bb2af7d5",
    image: "/assets/headshots/hope-holebrook.png",
  },
  {
    name: "Alyssa Albornaz",
    title: "Marketing Specialist",
    ownerId: "8cf396e3-2784-42dc-849f-2ce797eca145",
    image: "/assets/headshots/alyssa-albornoz.png",
  },
];

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/teams/fp/marketing",
  component: () => (
    <TeamRosterPage team="FP Marketing" members={members}>
      <LeadsByChannelCard />
    </TeamRosterPage>
  ),
});
